module.exports = __webpack_public_path__ + "img/word.7008755e.svg";